import type { NatalieVersion } from './api/types';

export const NATALIE_VERSION: NatalieVersion = 'v8';

/**
 * sessionStorage key holding the event id of the create_event ("Request a Natalie
 * Session") event the user was just routed into. The per-community create_event id
 * is dynamic and never in the VITE_APP_NATALIE_REQUEST_EVENT_IDS allowlist, so the
 * participant screens (DescriptionTab / Join) read this to show the non-anonymous
 * request-event copy for it (see isCreateEventRequestFlow). Like the confirmation
 * key, sessionStorage survives the landing → join → conversation round-trip.
 */
export const NATALIE_REQUEST_EVENT_ID_KEY = 'natalie-request-event-id';
